import React, { useCallback, useEffect, useRef, useState } from "react";
import { ReactComponent as DefaultBrandingIcon } from "../../../assets/previewPage/defaultBrandingIcon.svg";
import {
  AvatarCard,
  LinksCard,
  SocialCard,
  QrImageCard,
  FaqCard,
  ImageCard,
  DividerCard,
  ImageGridCard,
  CountDownCard,
  YoutubeCard,
  InstagramCard,
  TwitterCard,
  TikTokCard,
  HeadingCard,
  HeaderTextCard,
} from "./cards";
import { throttle } from "lodash";
import "./header.css";
// redux
import {
  gettingLinkList,
  resetLinkList,
} from "../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { gettingSettingUpdataData } from "../../../redux/slices/appearance/appearanceSlice";
import { useDispatch, useSelector } from "react-redux";
import "aos/dist/aos.css";
import SpinnerGiff from "../../../assets/spinner.svg";
import LocationCard from "./cards/LocationCard";
import useLocales from "../../../hooks/useLocales";
import CookiesPreferenceConfirmModal from "../../landingPages/CookiesPreferenceConfirmModal";
import { useNavigate } from "react-router-dom";
import HeaderTextStickyCard from "./cards/HeaderTextStickyCard";

const DashboardMobilePreview = ({ user }) => {
  const { currentLang, translate } = useLocales();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const baseUrl = process.env.REACT_APP_API_URL;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [backgroundStyles, setBackgroundStyles] = useState(null);
  const [brandingStyles, setBrandingStyles] = useState(null);
  // const [seoStyles, setSeoStyles] = useState(null);
  // const [favStyles, setFavStyles] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const headerTextCardRef = useRef(null); // Ref to track HeaderTextCard

  const mylinkstate = useSelector((state) => state?.linkList || []);
  const myData = mylinkstate?.getLinkList?.response;
  const [mylinkstateSorted, setLinkList] = useState([]);
  const filteredLinkData = mylinkstateSorted?.filter(
    (item) => item?.language === currentLang.value
  );
  useEffect(() => {
    setLinkList(myData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mylinkstate]);

  const userId = JSON.parse(localStorage.getItem("user"))?.userid;
  const linkId = localStorage?.getItem("linkId");
  const data = {
    linkData: linkId,
    userData: userId,
  };
  useEffect(() => {
    dispatch(gettingSettingUpdataData(data));
    if (linkId) {
      fetchingLinkList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);
  const getLinkState = useSelector((state) => state?.gettingBioLinksState);

  const fetchingLinkList = async () => {
    const linkId =
      localStorage.getItem("linkId") ||
      getLinkState?.getBioLink?.response?.[0]?._id;
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user.userid;
    const usertoken = user.token;
    const linkListData = {
      userId,
      usertoken,
      linkId,
    };
    if (linkId) {
      await dispatch(gettingLinkList(linkListData));
      dispatch(resetLinkList());
    }
  };

  const userLinkLoading = mylinkstate?.linkListLoading;
  const gettingAppearanceLoading = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearanceLoading
  );
  const LinkStyles = useSelector(
    (state) => state?.gettingAppearance?.gettingAppearance?.data?.response
  );
  const [linkStyles, setLinkStyles] = useState(LinkStyles);

  useEffect(() => {
    setLinkStyles(LinkStyles);
  }, [LinkStyles]);

  useEffect(() => {
    linkStyles?.map((item) => {
      if (item?.coloum_name === "background") {
        setBackgroundStyles(JSON.parse(item?.coloum_value));
      }
      if (item?.coloum_name === "branding") {
        setBrandingStyles(JSON.parse(item?.coloum_value));
      }
      // if (item?.coloum_name === "seo") {
      //   setSeoStyles({ ...item, coloum_value: JSON.parse(item?.coloum_value) });
      // }
      // if (item?.coloum_name === "favIcon") {
      //   setFavStyles(JSON.parse(item?.coloum_value));
      // }
      return null;
    });
  }, [linkStyles]);

  const bgImageStyle =
    backgroundStyles?.backgroundType === "abstractGradients"
      ? {
          backgroundImage: `url('${backgroundStyles?.backgroundOptionVal}')`,
        }
      : backgroundStyles?.backgroundType === "customColor"
      ? {
          background: backgroundStyles?.backgroundOptionVal,
        }
      : backgroundStyles?.backgroundType === "customImage"
      ? {
          backgroundImage: `url('${baseUrl}/profile/${backgroundStyles?.backgroundOptionVal}')`,
        }
      : {};

  const fonts =
    linkStyles?.filter((item) => item.coloum_name === "fonts")?.[0] || null;
  const fontValue = fonts?.coloum_value && JSON.parse(fonts?.coloum_value);

  const [fontStyle, setFontStyle] = useState(null);
  useEffect(() => {
    if (fontValue) {
      setFontStyle({ ...fontStyle, fontFamily: fontValue?.fontType?.value });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fonts]);
  const handleCookiePreferencesClick = () => {
    setIsModalOpen(true);
  };

  const handleReportAbuseClick = () => {
    navigate("/report-abuse");
  };

  const handleScroll = useCallback(
    throttle(() => {
      const scrollableContainer = document.getElementById("scroll-container");
      if (scrollableContainer && headerTextCardRef.current) {
        const scrollTop = scrollableContainer.scrollTop;
        const headerTextCardBottom =
          headerTextCardRef.current.getBoundingClientRect().bottom;

        // Check if HeaderTextCard has been fully scrolled past
        const isFullyScrolledPast = scrollTop > headerTextCardBottom;
        setIsSticky(isFullyScrolledPast);
      }
    }, 100),
    []
  );

  useEffect(() => {
    const scrollableContainer = document.getElementById("scroll-container");
    if (scrollableContainer) {
      scrollableContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollableContainer) {
        scrollableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll]);

  useEffect(() => {
    if (gettingAppearanceLoading || userLinkLoading) {
      const scrollableContainer = document.getElementById("scroll-container");
      if (scrollableContainer) {
        scrollableContainer.scrollTop = 0;
      }
      setIsSticky(false);
    }
  }, [gettingAppearanceLoading, userLinkLoading]);

  return (
    <>
      {gettingAppearanceLoading || userLinkLoading ? (
        <div
          style={{ zIndex: "999999999999" }}
          className="inset-0 max-h-full h-full min-h-full bg-[#FFDDDB] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      ) : (
        <div
          style={bgImageStyle}
          className={`flex justify-center ${
            backgroundStyles?.backgroundType === "simpleGradients"
              ? backgroundStyles?.backgroundOptionVal
              : backgroundStyles?.backgroundType === "abstractGradients"
              ? "bg-cover bg-center bg-no-repeat"
              : backgroundStyles?.backgroundType === "customImage"
              ? "bg-cover bg-center bg-no-repeat"
              : ""
          } ${
            !backgroundStyles
              ? "bg-gradient-to-b from-[#9BF5BB] to-[#4F8BC1]"
              : ""
          } max-h-full min-h-full overflow-y-auto overflow-x-clip no-scrollbar`}
          id="scroll-container"
          onScroll={handleScroll}
        >
          <div
            className={`md:max-w-[301px] w-full flex flex-col h-full justify-between`}
          >
            {isSticky && (
              <div
                className={`flex flex-col gap-[20px] items-center ${
                  isSticky ? "sticcky" : ""
                }`}
              >
                {filteredLinkData?.map((item) => {
                  if (item.coloum_name === "headertext" && item.status) {
                    return (
                      <HeaderTextStickyCard
                        key={item._id}
                        item={item}
                        styles={linkStyles}
                        isSticky={isSticky}
                      />
                    );
                  }
                  return null;
                })}
              </div>
            )}
            <div
              className={`flex flex-col gap-[20px] items-center`}
              ref={headerTextCardRef}
            >
              {filteredLinkData?.map((item) => {
                if (item.coloum_name === "headertext" && item.status) {
                  return (
                    <HeaderTextCard
                      key={item._id}
                      item={item}
                      styles={linkStyles}
                    />
                  );
                }
                return null;
              })}
            </div>

            <div className="flex flex-col gap-[20px] items-center px-[20px] pt-[20px]">
              {filteredLinkData?.map((item, i) => {
                switch (item.coloum_name) {
                  case "link":
                    return item?.status ? (
                      <LinksCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "avatar":
                    return item?.status ? (
                      <AvatarCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "share":
                    return item?.status ? (
                      <QrImageCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "faq":
                    return item?.status ? (
                      <FaqCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "youtube":
                    return item?.status ? (
                      <YoutubeCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "tiktok":
                    return item?.status ? (
                      <TikTokCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "instagram":
                    return item?.status ? (
                      <InstagramCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "twitter":
                    return item?.status ? (
                      <TwitterCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "image":
                    return item?.status ? (
                      <ImageCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "imageGrid":
                    return item?.status ? (
                      <ImageGridCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "divider":
                    return item?.status ? (
                      <DividerCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "countdown":
                    return item?.status ? (
                      <CountDownCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "heading":
                    return item?.status ? (
                      <HeadingCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "social":
                    return item?.status ? (
                      <SocialCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  case "mapData":
                    return item?.status ? (
                      <LocationCard
                        key={item?._id}
                        item={item}
                        styles={linkStyles}
                      />
                    ) : null;
                  default:
                    return null;
                }
              })}
            </div>
            <div className="pb-[100px] md:pb-[50px] px-[20px] pt-[40px]">
              <div className="flex justify-center">
                {brandingStyles ? (
                  brandingStyles?.brandingStatus ? (
                    brandingStyles?.brandingTitle ? (
                      <a
                        href={brandingStyles?.brandingUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <p
                          style={fontStyle}
                          className="text-body_copy2_black text-center"
                        >
                          {brandingStyles?.brandingTitle}
                        </p>
                      </a>
                    ) : (
                      <a href={"/bill"} target="_blank" rel="noopener noreferrer">
                        <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                      </a>
                    )
                  ) : brandingStyles?.paidUser ? null : (
                    <a href={"/bill"} target="_blank" rel="noopener noreferrer">
                      <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                    </a>
                  )
                ) : (
                  <a
                    href={"/bill"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex justify-center items-center"
                  >
                    <DefaultBrandingIcon className="w-[80.3px] md:w-auto" />
                  </a>
                )}
              </div>
              <div className="mt-[16px] sm:mt-[20px] flex justify-center items-center text-dark_bg_v1">
                <p
                  className="text-small3 sm:text-small2_b cursor-pointer"
                  onClick={handleReportAbuseClick}
                >
                  {translate("header.ReportAbuse")}&nbsp;·
                </p>
                <div
                  className="cursor-pointer text-small3 sm:text-small2_b"
                  onClick={handleCookiePreferencesClick}
                >
                  &nbsp;
                  {translate("footer.Update_cookies_preferences")}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <CookiesPreferenceConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default DashboardMobilePreview;
